import React, { useState } from "react";

import "./stylesUserActivityTable.css";
import RebetLoader from "../../CommonComponents/RebetLoader/RebetLoader";
import AllActivityTable from "./AllActivityTable/AllActivityTable";
import TransactionsTable from "./TransactionsTable/TransactionsTable";
import FraudulentOptionsTable from "./FraudulentOptionsTable/FraudulentOptionsTable";
import AgreementsTable from "./AgreementsTable/AgreementsTable";
import PromoTable from "./PromoTable/PromoTable";
import CustomDatePicker from "../../CommonComponents/CustomDatePicker/CustomDatePicker";

import dayjs from "dayjs";
import { DownloadOutlined } from "@ant-design/icons";

function UserActivityTable() {
  const todayRange = [dayjs(), dayjs()];
  const [sportsBookDates, setSportsBookDates] = useState(todayRange);

  const [isApiRunning, setIsApiRunning] = useState(false);
  const [activeTab, setActiveTab] = useState("All activity");

  return (
    <div className="user-activity-container">
      <div className="user-activity-content">
        <>
          <div className="user-activity-header-content">
            <h2>User Activity</h2>
            <div className="user-activity-header-content-right">
              <CustomDatePicker
                getData={() => {}}
                dates={sportsBookDates}
                setDates={setSportsBookDates}
                showQuickSelect={true}
                showPresets={true}
              />
              <DownloadOutlined className="download-icon" />
            </div>
          </div>
          <div style={{ width: "100%" }}>
            {isApiRunning ? (
              <RebetLoader height={"100px"} width={"100px"} />
            ) : (
              <>
                <div className="user-activity-tabs">
                  <div
                    className={`user-activity-tab ${
                      activeTab === "All activity" ? "active" : ""
                    }`}
                    onClick={() => setActiveTab("All activity")}
                  >
                    All activity
                  </div>
                  <div
                    className={`user-activity-tab ${
                      activeTab === "Transactions" ? "active" : ""
                    }`}
                    onClick={() => setActiveTab("Transactions")}
                  >
                    Transactions
                  </div>
                  <div
                    className={`user-activity-tab ${
                      activeTab === "Fraudulent operations" ? "active" : ""
                    }`}
                    onClick={() => setActiveTab("Fraudulent operations")}
                  >
                    Fraudulent operations
                    <p className="red-circle"></p>
                  </div>
                  <div
                    className={`user-activity-tab ${
                      activeTab === "Agreements" ? "active" : ""
                    }`}
                    onClick={() => setActiveTab("Agreements")}
                  >
                    Agreements
                  </div>
                  <div
                    className={`user-activity-tab ${
                      activeTab === "Promo" ? "active" : ""
                    }`}
                    onClick={() => setActiveTab("Promo")}
                  >
                    Promo
                  </div>
                </div>
                <div className="user-activity-active-table-container">
                  {activeTab === "All activity" && <AllActivityTable />}
                  {activeTab === "Transactions" && <TransactionsTable />}
                  {activeTab === "Fraudulent operations" && (
                    <FraudulentOptionsTable />
                  )}
                  {activeTab === "Agreements" && <AgreementsTable />}
                  {activeTab === "Promo" && <PromoTable />}
                </div>
              </>
            )}
          </div>
        </>
      </div>
    </div>
  );
}

export default UserActivityTable;
